import { CAPTION_DWELL_OPTIONS, CAPTION_EXPRESSIVE_MODE_OPTIONS, CAPTION_SIZE_OPTIONS } from './captionPreferences';
import { getCaptionPresentationMode } from './captionTone';
/** Translate UI labels while retaining the shared, persisted option values. */
export function getCaptionChoices(t, surface) {
    return {
        dwell: CAPTION_DWELL_OPTIONS.map(({ value }) => ({
            label: t(`captionSettings.dwellNames.${value}`), value
        })),
        modes: CAPTION_EXPRESSIVE_MODE_OPTIONS.filter(({ value }) => !surface || getCaptionPresentationMode(value, surface) === value).map(({ value }) => ({
            label: t(`captionSettings.modeNames.${value}`), value
        })),
        sizes: CAPTION_SIZE_OPTIONS.map(({ value }) => ({
            label: t(`captionSettings.sizeNames.${value}`), value
        }))
    };
}
/** The normalized presentation decides whether a tentative hint is allowed. */
export function getLocalizedCaptionToneHint(presentation, t) {
    return presentation.accessibilityLabel && presentation.tone !== 'neutral'
        ? t(`captionToneHints.${presentation.tone}`) : undefined;
}
export function formatCaptionTime(timestamp, language) {
    return new Date(timestamp).toLocaleTimeString(language || undefined, {
        hour: '2-digit', minute: '2-digit', second: '2-digit'
    });
}
/** Narrow the legacy react-i18next instance declaration at this UI boundary. */
export function getCaptionLanguage(instance) {
    if (!instance || typeof instance !== 'object')
        return undefined;
    if ('resolvedLanguage' in instance && typeof instance.resolvedLanguage === 'string') {
        return instance.resolvedLanguage;
    }
    return 'language' in instance && typeof instance.language === 'string' ? instance.language : undefined;
}
